import { Pipe, PipeTransform } from '@angular/core';
import { CoordinateFormat, CoordinateV1 } from './coordinate.model';
import { CoordinateKind } from './coordinate.model.v2';

interface LatLngCoordinates {
  latitude: string | number | null;
  longitude: string | number | null;
}

@Pipe({ name: 'coordinates' })
export class CoordinatesPipe implements PipeTransform {
  public transform(value: LatLngCoordinates, format?: CoordinateFormat): any {
    const lat = new CoordinateV1(value.latitude, CoordinateKind.Latitude);
    const lng = new CoordinateV1(value.longitude, CoordinateKind.Longitude);
    return `${lat.toString(format)}, ${lng.toString(format)}`;
  }
}
